var StringBuilder = /*#__PURE__*/function () {
  StringBuilder.create = function create() {
    return new StringBuilder();
  };
  function StringBuilder(strings) {
    if (strings === void 0) {
      strings = [];
    }
    this.strings = strings;
  }
  var _proto = StringBuilder.prototype;
  _proto.add = function add(value) {
    return new StringBuilder(this.strings.concat([value]));
  };
  _proto.build = function build(separator) {
    if (separator === void 0) {
      separator = '';
    }
    return this.strings.join(separator);
  };
  return StringBuilder;
}();
export default StringBuilder;